module.exports = "<div class=\"loader\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loader/loader.component.html
// module id = ./src/app/components/loader/loader.component.html
// module chunks = main